





































import customerApi from "@/api/customerApi";
import qNotify from "@/common/qNotify";
import Contract, { CONTRACT_ACCEPTION, CONTRACT_STATUS } from "@/model/contract";
import {Component, Mixins} from "vue-property-decorator";
import Authority from "@/common/mixins/authority";
import User from "@/model/user";
import {namespace} from "vuex-class";
import store from "@/store";
const auth = namespace("Auth");

@Component({
  name: "CustomerContractAccept",
})
export default class CustomerContractAccept extends Mixins(Authority) {
  @auth.Getter
  getUserLogging!: User;

  public contractObject: Contract = new Contract();
  public isShow = false;

  mounted() {
    this.getDetail();
  }
  get contractId() {
    return this.$router.currentRoute.params.id;
  }
  public async getDetail() {
    const result = await customerApi.detailContract(this.contractId);
    this.contractObject = result;

    if (this.contractObject.status === CONTRACT_STATUS.CLOSE) {
      qNotify.error({
        text: "contract.contract_was_expired",
      });
      this.$router.push({
        name: "login",
      });
    } else if (this.contractObject.is_accept === CONTRACT_ACCEPTION.ACCEPT || this.contractObject.is_accept === CONTRACT_ACCEPTION.REJECT) {
      qNotify.error({
        text: "contract.contract_was_accepted",
      });
      this.$router.push({
        name: "login",
      });
    } else {
      this.isShow = true;
    }
  }

  public accept() {
    this.submit(CONTRACT_ACCEPTION.ACCEPT);
  }

  public reject() {
    this.submit(CONTRACT_ACCEPTION.REJECT);
  }

  public async submit(type) {
    const result = await customerApi.acceptContract(this.contractId, type);

    if (result.meta.status === 200) {
      qNotify.success({
        text:
          type === CONTRACT_ACCEPTION.REJECT
            ? this.$t("contracts.rejected")
            : this.$t("contracts.accepted"),
      });

      if(type == CONTRACT_ACCEPTION.ACCEPT) {
        store.dispatch("Auth/logout");
      }
      this.$router.push({
        name: "login",
      });
      return;
    } else {
      qNotify.error({
        text: result.meta.message,
      });
    }
  }
}
